export default __webpack_public_path__ + "static/media/Customization Tools2.19c9ecd1.svg";